package com.gastoncantera.intercom.ui

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable

/**
 * Confirmación de cerrar sesión, compartida por los dos roles: cerrar sesión no se deshace (hay que
 * volver a entrar) y en ninguno de los dos casos es algo que se quiera hacer de un toque.
 *
 * El portero además puede tener PIN (`LogoutPinDialog`), que reemplaza a esta confirmación.
 */
@Composable
fun LogoutConfirmDialog(
    message: String,
    onDismiss: () -> Unit,
    onConfirmed: () -> Unit,
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text("Cerrar sesión") },
        text = { Text(message) },
        confirmButton = {
            TextButton(onClick = onConfirmed) { Text("Cerrar sesión") }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) { Text("Cancelar") }
        },
    )
}
